import Common from "../common/Common";

class Pagenav3 {
  constructor() {
    this.common = new Common();
    this.mediaQueryList = this.common.matchMedia("md");
    this.pagenav3 = document.querySelectorAll(".js-pagenav3");

    this.initialize();
  }

  initialize() {
    this.mediaQueryList.addEventListener("change", this.resize.bind(this));

    if( this.pagenav3 ) {
      this.fixed1()
    }

  }

  // ウィンドウサイズ変更時の処理
  resize() {
    if (this.mediaQueryList.matches) {
      // SPサイズになった時の処理
    } else {
      // PCサイズになった時の処理
    }
  }

  fixed1() {
    const targets = this.pagenav3;

    targets.forEach((target, index) => {
      // initialize
      const targetH = target.offsetHeight;
      target.style.height = targetH + "px";
      const targetInner = target.querySelector(".c-pagenav3__inner1");

      window.addEventListener("scroll", () => {
        // fix
        const startPos = target.getBoundingClientRect().top;
        const targetInnerH = targetInner.offsetHeight;
        const area = target.closest(".c-smAccordion1__panel1");
        const areaH = area.clientHeight;
        const endPos = startPos + areaH;

        if( 0 > startPos && 0 < endPos - targetInnerH) {
          target.classList.add('is-smFixed1');
        } else if( 0 < startPos + targetInnerH ) {
          target.classList.remove('is-smFixed1');
        } else {
          target.classList.remove('is-smFixed1');
        }
      });
    });
  }
}

export default Pagenav3;